import { FILTER_GROUPS, isEmpty, splitList, STUDY_STATUS_OPTIONS, STUDY_TYPE_OPTIONS, yesNo } from "../../quick-filter/ExtraFilters";

/**
 * Çekim grid'inin "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde (StudyFilter) duran
 * filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır; gruplar (FILTER_GROUPS)
 * ilk alanlarının sırasıyla dizildiği için aynı gruptakiler yan yana tutulur.
 */
export const STUDY_EXTRA_FIELDS = [
    {
        key: 'patientId', group: FILTER_GROUPS.PATIENT,
        label: 'Patient Id',
        kind: 'list',
        empty: undefined,
        // Sol panel metni patientId'de, sunucuya giden diziyi patientIdList'te tutar (bkz. StudyFilter.filter).
        isActive: (filter) => !isEmpty(filter.patientIdList) || !isEmpty(`${filter.patientId ?? ''}`.trim()),
        toDraft: (filter) => (!isEmpty(filter.patientIdList) ? filter.patientIdList.join(', ') : (filter.patientId ?? '')),
        toFilter: (value) => {
            const items = splitList(value);
            return { patientId: items.length ? items.join(', ') : undefined, patientIdList: items };
        },
        clearChanges: { patientId: undefined, patientIdList: [] },
    },
    { key: 'patientName', group: FILTER_GROUPS.PATIENT, label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'accessionNumber', group: FILTER_GROUPS.PATIENT, label: 'Accession No', kind: 'text', empty: undefined },
    { key: 'idList', group: FILTER_GROUPS.PATIENT, label: 'Study Id List', kind: 'list', empty: [] },
    { key: 'studyInstanceUIDList', group: FILTER_GROUPS.PATIENT, label: 'Study UID', kind: 'list', empty: [] },
    { key: 'hospitalGroupIdList', group: FILTER_GROUPS.SCOPE, label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [], permissions: ['HOSPITAL_GROUP_FILTER'] },
    { key: 'hospitalIdList', group: FILTER_GROUPS.SCOPE, label: 'Hospitals', kind: 'lookup', source: 'hospitals', empty: [] },
    { key: 'institutions', group: FILTER_GROUPS.SCOPE, label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
    {
        key: 'listIdList', group: FILTER_GROUPS.SCOPE,
        label: 'Lists',
        kind: 'lookup',
        source: 'lists',
        empty: null,
        permissions: ['LIST_VIEW', 'LIST_VIEW_ALL', 'LIST_CREATE', 'LIST_ITEM_ADD'],
        // Liste filtresinde boş dizi "imkânsız sonuç" demek (bkz. study-filter-query) → null.
        toFilter: (value) => ({ listIdList: value?.length ? value : null }),
    },
    { key: 'studyTypeList', group: FILTER_GROUPS.WORK, label: 'Study Type', kind: 'select', multiple: true, options: STUDY_TYPE_OPTIONS, empty: [], work: true },
    { key: 'studyStatus', group: FILTER_GROUPS.WORK, label: 'Study Status', kind: 'select', multiple: true, options: STUDY_STATUS_OPTIONS, empty: [], work: true },
    { key: 'isRead', group: FILTER_GROUPS.WORK, label: 'Is Read', kind: 'select', options: yesNo('Read', 'Not Read'), empty: null, work: true },
    { key: 'isReportable', group: FILTER_GROUPS.WORK, label: 'Is Reportable', kind: 'select', options: yesNo('Reportable', 'Not Reportable'), empty: true, allOption: true, permissions: ['SET_STUDY_REPORTABLE'] },
    { key: 'hasOpenTask', group: FILTER_GROUPS.WORK, label: 'Open Task', kind: 'select', options: yesNo('Has Open Task', 'No Task'), empty: null },
    { key: 'assignDoctor', group: FILTER_GROUPS.PEOPLE, label: 'Assigned (Doctor)', kind: 'assign', source: 'readableUsers', pickPermission: 'STUDY_ASSIGN_DOCTOR_USER', empty: null, work: true, permissions: ['STUDY_SET_READ'] },
    { key: 'assignReporter', group: FILTER_GROUPS.PEOPLE, label: 'Assigned (Reporter)', kind: 'assign', source: 'writableUsers', pickPermission: 'STUDY_ASSIGN_REPORTER_USER', empty: null, work: true, permissions: ['REPORT_ADD_OR_EDIT'] },
    { key: 'readUserId', group: FILTER_GROUPS.PEOPLE, label: 'Read User', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'writeUserId', group: FILTER_GROUPS.PEOPLE, label: 'Wrote User', kind: 'user', source: 'writableUsers', userType: 'write', empty: undefined },
    { key: 'hasAiDicom', group: FILTER_GROUPS.OTHER, label: 'AI Dicom', kind: 'select', options: yesNo('TRUE', 'FALSE'), empty: null },
    { key: 'isDeleted', group: FILTER_GROUPS.OTHER, label: 'Is Deleted', kind: 'select', options: yesNo('Deleted', 'Not Deleted'), empty: false, allOption: true, permissions: ['STUDY_LIST_DELETED'] },
    {
        key: 'hl7FilterType', group: FILTER_GROUPS.OTHER,
        label: 'HL7 Filter',
        kind: 'select',
        options: [{ value: 1, label: 'HAS_NO_HL7_MESSAGE' }],
        empty: undefined,
        isActive: (filter) => !!filter.hl7FilterType,   // 0 = "Tümü"
    },
];
